import React from 'react'
import { TEXT_KEYS } from '../../constants/textKeys'
import { t } from '../../translation/translation'
import './style.css'

export const ConfidentialityAgreement = () => {
    return (
        <div className='type-policy-container page-container'>
            <h3>{t(TEXT_KEYS.CONFIDENTIALITY_AGREEMENT_TITLE)}</h3>
            <div className='type-policy-container-policy'>
                <h4>{t(TEXT_KEYS.CONFIDENTIALITY_AGREEMENT_TITLE_1)}</h4>
                <p>{t(TEXT_KEYS.CONFIDENTIALITY_AGREEMENT_DESCRIPTION_1)}</p>
                <h4>{t(TEXT_KEYS.CONFIDENTIALITY_AGREEMENT_TITLE_2)}</h4>
                <p>{t(TEXT_KEYS.CONFIDENTIALITY_AGREEMENT_DESCRIPTION_2)}</p>
                <h4>{t(TEXT_KEYS.CONFIDENTIALITY_AGREEMENT_TITLE_3)}</h4>
                <p>{t(TEXT_KEYS.CONFIDENTIALITY_AGREEMENT_DESCRIPTION_3)}</p>
                <h4>{t(TEXT_KEYS.CONFIDENTIALITY_AGREEMENT_TITLE_4)}</h4>
                <p>{t(TEXT_KEYS.CONFIDENTIALITY_AGREEMENT_DESCRIPTION_4)}</p>
                <ul>
                    <li>{t(TEXT_KEYS.CONFIDENTIALITY_AGREEMENT_DESCRIPTION_4_1)}</li>
                    <li>{t(TEXT_KEYS.CONFIDENTIALITY_AGREEMENT_DESCRIPTION_4_2)}</li>
                    <li>{t(TEXT_KEYS.CONFIDENTIALITY_AGREEMENT_DESCRIPTION_4_3)}</li>
                </ul>
                <h4>{t(TEXT_KEYS.CONFIDENTIALITY_AGREEMENT_TITLE_5)}</h4>
                <p>{t(TEXT_KEYS.CONFIDENTIALITY_AGREEMENT_DESCRIPTION_5)}</p>
                <h4>{t(TEXT_KEYS.CONFIDENTIALITY_AGREEMENT_TITLE_6)}</h4>
                <p>{t(TEXT_KEYS.CONFIDENTIALITY_AGREEMENT_DESCRIPTION_6)}</p>
                <h4>{t(TEXT_KEYS.CONFIDENTIALITY_AGREEMENT_TITLE_7)}</h4>
                <p>{t(TEXT_KEYS.CONFIDENTIALITY_AGREEMENT_DESCRIPTION_7)}</p>
            </div>

        </div>
    )
}

export default ConfidentialityAgreement